module.exports = __webpack_public_path__ + "static/media/soc_bluesky.67ee1e79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/soc_bluesky.svg
// module id = 386
// module chunks = 0